import { useFeatureFlags } from './useFeatureFlags'
import * as consts from './featureFlags.constants'
import { FeatureFlagTypeMap } from '../App/app.api'

/** @deprecated. Use featureFlagValue instead.  */
export function useFeatureAvailable<FlagName extends keyof FeatureFlagTypeMap>(flag?: FlagName): FeatureFlagTypeMap[FlagName] | boolean {
  const featureFlags = useFeatureFlags()
  // TODO: remove all type coercion from this file and adjust the logic accordingly
  switch (featureFlags.launchDarklyProps?.implementation) {
    case consts.PROPERTY_FILE_IMPLEMENTATION: {
      const fileProps = featureFlags.launchDarklyProps.properties
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
      return fileProps[flag as FlagName] ? fileProps[flag as FlagName] === 'true' : false
    }
    case consts.LAUNCHDARKLY_IMPLEMENTATION:
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
      return featureFlags.featureFlagClient?.variation(flag as FlagName, false)
    default:
      return false
  }
}
